@use "/src/styles/functions.scss";

.passwordStrength {
  display: flex;
  flex-direction: column;
  gap: functions.space(8);
}
.passwordStrength_statusLines {
  display: flex;
  flex-direction: row;
  gap: functions.space(8);
}
.statusLine {
  flex-grow: 1;
  height: 4px;
  border-radius: 1.2px;
}
.passwordStrength_rule {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: functions.space(4);
}
